function n(r, o) {
  console.error(`[vdirs/${r}]: ${o}`);
}
export {
  n as warn
};
